<!-- <app-mapbox-ficha-detalle></app-mapbox-ficha-detalle> -->
<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo-catalogacion.jpg"
  style="background-image: url('assets/img/fondo-catalogacion.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white;">Catalogación de Inmuebles Urbanos</h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section mt-80 mt-md-60 mt-sm-40 mb-30" style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap">
          <h2>Mapa de Consulta de Fichas de inmuebles urbanos</h2>
          <p class="mb-0" style="font-weight: 300;">El siguiente mapa interactivo, muestra todos los inmuebles
            catalogados del Centro Histórico de Cusco, divididos por los 09
            sectores de gestión delimitados en nuestro mapa por lineas de colores distintivos de cada sector, además el
            mapa muestra una clasificación de los inmuebles por las categorias de catalogación y la delimitación por
            área de estructuración.<br>
            A continuación se describirá los sectores de gestión, categorias de catalogación y las delimitaciones por
            área de estructuración, para la mejor interacción
            con el mapa y su información.</p>
        </div>
      </div><!-- End Section title -->
    </div>
    <div class="row">
      <div class="col-lg-4">
        <figure class="welcome-thumbnail"><img src="assets/img/mapa-catalogacion.png" alt="Welcome Image" width="700"
            style="margin-left:80px;"></figure>
      </div>
      <div class="col-lg-8">
        <h3 style="font-size: 18px; margin-bottom: 30px;" class="text-center">LEYENDA MAPA DE CATALOGACIÓN</h3>
        <div class="welcome-feature mt-sm-32 mt-md-36">
          <div class="row">
            <!-- Start Single Welcome Feature -->
            <div class="col-md-6">
              <h4 style="font-size: 18px;margin-bottom: -30px;" class="mb-sm-20 mb-md-20">Sectores de Gestión</h4>
              <div class="single-welcome-feature d-flex">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#E7E408"></i></div>
                <div class="feature-info">
                  <p>Borde color amarillo: SG-01 - Núcleo de Centro Histórico</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#F6990E"></i></div>
                <div class="feature-info">
                  <p>Borde color anaranjado: SG-02 - San Cristóbal</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#F9101C"></i></div>
                <div class="feature-info">
                  <p>Borde color rojo: SG-03 - Santo Domingo y San Agustín</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#047613"></i></div>
                <div class="feature-info">
                  <p>Borde color verde: SG-04 - San Blas y Rimacpampa</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#BB0707"></i></div>
                <div class="feature-info">
                  <p>Borde color guinda: SG-05 - Santa Ana</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#0895C9"></i></div>
                <div class="feature-info">
                  <p>Borde color celeste: SG-06 - San Pedro</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:#BA06CB"></i></div>
                <div class="feature-info">
                  <p>Borde color lila: SG-07 - Pumacchupan, Av. Pardo y Tres Cruces</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:black"></i></div>
                <div class="feature-info">
                  <p>Borde color negro: SG-08 - Almudena, Belén y Santiago </p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:black"></i></div>
                <div class="feature-info">
                  <p>Borde color negro: SG-09 - Totorapaccha, Mesa Redonda y Teteqaqa</p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <h4 style="font-size: 18px; margin-bottom: -30px;" class="mb-sm-20 mb-md-20">Características de
                Catalogación</h4>
              <div class="single-welcome-feature d-flex">
                <div class="feature-icon"><i class="fa fa-home" style="color:#941D9E"></i></div>
                <div class="feature-info">
                  <p>(PM-I) Inmuebles declarados patrimonio monumental</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-home" style="color:#F35DDE"></i></div>
                <div class="feature-info">
                  <p>(PM-I) Inmuebles declarados patrimonio monumental</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-home" style="color:#F33433"></i></div>
                <div class="feature-info">
                  <p>(PI-II) Inmuebles con valor o características Patrimoniales Individuales</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-home" style="color:#EBF133"></i></div>
                <div class="feature-info">
                  <p>(VC-III) Inmuebles con Valor Contextual</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-home" style="color:#F4C653"></i></div>
                <div class="feature-info">
                  <p>(EP-IV) Inmuebles con algún elemento artistico y/o patrimonial</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-home" style="color:#41E1EF"></i></div>
                <div class="feature-info">
                  <p>(SV-V) Inmuebles Sin Valor Patrimonial específico en superficie o predios sin construir</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex">
                <div class="feature-icon"></div>
                <div class="feature-info">
                  <h3>Delimitación por Área de estructuración</h3>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:darkgray"></i></div>
                <div class="feature-info">
                  <p>Bordes de todos los colores de los sectores: AE-I Centro Histórico</p>
                </div>
              </div>
              <div class="single-welcome-feature d-flex" style="margin-top:-5px;">
                <div class="feature-icon"><i class="fa fa-stop" style="color:black"></i></div>
                <div class="feature-info">
                  <p>Borde color negro: AE-II Área circundante de protección</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="showcase-description-area mt-40 mt-md-30 mt-sm-20 mb-30 mb-md-30 mb-sm-30 pb-20" style="background-color:#F4F4F4">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap mt-50">
          <h2>BUSQUEDA DE INFORMACIÓN DE INMUEBLES</h2>
          <p class="mb-0" style="font-weight: 400;">
            El mapa de catalogación de inmuebles del Centro Histórico del Cusco, nos brindará información arquitectónica, arqueológica e Histórica de los distintos
            inmuebles catalogados en los 09 sectores de gestión, el mismo que se encontrará accesesible para el público en general.
            Para el uso del mapa interactivo adecuado, seguiremos los siguientes pasos:</p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top:-100px;">
      <div class="col-12">
        <div class="showcase-description-content mt-lg-10 mt-xl-10">
          <div class="row">

            <div class="col-md-4">
              <div class="single-desc-item-wrap"><span class="desc-number mb-10">1°</span>
                <p>Debemos de ubicarnos en el inmueble que se desea consultar, para esto primero ubicamos el barrio o sector gestión y luego
                  el inmueble, para ello usted podrá incrementar el zoom de navegación del mapa, asi como tambien deslizarlo a la izquierda y derecha.</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-desc-item-wrap"><span class="desc-number mb-10">2°</span>
                <p>Una vez que tenemos ubicado el inmueble que deseamos consultar, hacemos click sobre la forma del terreno del predio,
                  el mismo que nos llevará a una ventana que habilitará el botón de <strong>"VER MÁS"</strong>, hacemos click en el para visualizar la información del inmueble.</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-desc-item-wrap"><span class="desc-number mb-10">3°</span>
                <p>Una vez en la información del inmueble a consultar, podremos observación información arquitectónica, arqueológica e histórica del predio selccionado;
                  esta información correponde a la catalogación realizada en los del centro histórico del Cusco.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-mapbox-ficha-detalle></app-mapbox-ficha-detalle>
